import { trackEvent, trackEcommerce } from 'dibs-tracking';

const LIST_NAME = 'recently viewed items carousel';

const trackInteraction = ({ action, label }) => {
    trackEvent({
        category: 'promo interaction',
        action,
        label,
        value: 0,
    });
};

const trackViewMoreCtaClick = ({ label }) => {
    trackInteraction({
        action: 'recently viewed view more clicked',
        label,
    });
};

export const trackHpViewMoreCtaClick = () => trackViewMoreCtaClick({ label: '[homepage]' });
export const trackPdpViewMoreCtaClick = () => trackViewMoreCtaClick({ label: '[pdp]' });
export const trackSbViewMoreCtaClick = () => trackViewMoreCtaClick({ label: '[s&b]' });

export const trackInitialDisplay = ({ itemsReturned }) => {
    trackInteraction({
        action: 'recently viewed items displayed',
        label: itemsReturned,
    });
};

export const trackArrowClick = ({ direction }) => {
    trackInteraction({
        action: 'recently viewed items arrow clicked',
        label: direction,
    });
};

export const trackItemClick = () => {
    trackInteraction({
        action: 'recently viewed items item clicked',
        label: 'none',
    });
};

export const trackRecentItems = ({ type, items, startIndex, variant }) => {
    trackEcommerce({
        type,
        actionField: { list: LIST_NAME },
        products: items.map((item, index) => ({
            brand: item.dealerPk,
            category: item.itemBrowseUrl || item.category,
            categoryCode: item.itemCategoryCode,
            id: item.itemId,
            variant,
            name: item.itemTitle,
            list: LIST_NAME,
            dimension83: item.contemporaryTrackingString,
            position: startIndex + index,
        })),
    });
};
